import React, { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { RootState } from '../../../redux/store';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import { KTIcon } from '../../../_metronic/helpers/components/KTIcon';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator, storeAreYouSureModalCallback, storeImageViewer } from '../../../redux/reducers/authSlice';
import { AmbarService } from '../../../services/AmbarService';
import TableFooter from '../../../components/TableFooter';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { GetCompanyListResponse, GetCompanyListResponseItem } from '../../../models/response/company/GetCompanyListResponse';
import { CompanyService } from '../../../services/CompanyService';
import { CustomSingleSelectModel } from '../../../components/CustomSingleSelect';
import { GetConstantListResponse } from '../../../models/response/constant/GetConstantListResponse';
import { ConstantService } from '../../../services/ConstantService';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import { GetAmbarListPagingAndFilterRequest, initialGetAmbarListPagingAndFilterRequest } from '../../../models/request/ambar/GetAmbarListPagingAndFilterRequest';
import { GetAmbarListPagingAndFilterResponse, GetAmbarListPagingAndFilterResponseData, GetAmbarListPagingAndFilterResponseItem, initialGetAmbarListPagingAndFilterResponseData } from '../../../models/response/ambar/GetAmbarListPagingAndFilterResponse';
import AmbarListFilters from './Components/AmbarListFilters';
import { GetCountryListResponse, GetCountryListResponseData } from '../../../models/response/country/GetCountryListResponse';
import { CountryService } from '../../../services/CountryService';
import { UyumsoftService } from '../../../services/UyumsoftService';
import { SaveAsDraftIrsaliyeResponse } from '../../../models/response/uyumsoft/SaveAsDraftIrsaliyeResponse';
import { CancelDraftIrsaliyeResponse } from '../../../models/response/uyumsoft/CancelDraftIrsaliyeResponse';
import { MoveToDraftIrsaliyeResponse } from '../../../models/response/uyumsoft/MoveToDraftIrsaliyeResponse';
import { ExportAmbarListResponse } from '../../../models/response/ambar/ExportAmbarListResponse';
import { DeleteAmbarResponse } from '../../../models/response/ambar/DeleteAmbarResponse';
import Box from '../../../components/Box';
import { useSortableColumns } from '../../../helpers/useSortableColumns';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions, ColumnFilterOption } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { loadConstants, loadList, YES_NO_FILTER } from '../../../components/ColumnFilter/columnFilterOptions';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import StatusBadge from '../../../components/StatusBadge';
import { ServiceService } from '../../../services/ServiceService';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';
import { JobQueueService } from '../../../services/JobQueueService';
import { EnqueueJobResponse } from '../../../models/response/jobQueue/JobQueueResponses';
import { jobQueueTracker, JOB_QUEUE_BATCH_COMPLETED_EVENT } from '../../../helpers/jobQueueTracker';
import GibConfirmModal from './Components/GibConfirmModal';
import CancelDraftConfirmModal from './Components/CancelDraftConfirmModal';

const AmbarList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "Kargo Modülü > Nakliye > Siparişler"
    const pageVersion = "9";
    const [data, setData] = useState<GetAmbarListPagingAndFilterResponseData>(initialGetAmbarListPagingAndFilterResponseData);
    const [filter, setFilter] = useState<GetAmbarListPagingAndFilterRequest>(initialGetAmbarListPagingAndFilterRequest)
    const [trCountry, setTrCountry] = useState<GetCountryListResponseData | undefined>(undefined);

    /**
     * Kolon listesi tarayicida kullaniciya ozel saklanir. Eskiden kayitli liste
     * varsa oldugu gibi donuyordu; bu yuzden SONRADAN EKLENEN bir kolon, ekrani
     * daha once acmis kullanicida hic gorunmuyordu (01.10.2026, "Not" kolonu).
     * Artik kayitli duzen korunur, varsayilanda olup kayitta olmayan kolonlar
     * sonuna eklenir.
     */
    const getColumns = (): ColumnChooserModel[] => {
        var varsayilanlar: ColumnChooserModel[] = [
            { title: 'Ref No', name: 'refNo', order: 0, isVisible: true },
            { title: 'Müşteri', name: 'customerName', order: 0, isVisible: true },
            { title: 'Aktarım Tarihi', name: 'transferDateStr', order: 0, isVisible: true },
            { title: 'Taşıma Yöntemi', name: 'carryTypeName', order: 0, isVisible: true },
            { title: 'Taşıma Tipi', name: 'carryMethodName', order: 0, isVisible: true },
            { title: 'Sipariş Durumu', name: 'orderStatusName', order: 0, isVisible: true },
            { title: 'Bekleme Süresi', name: 'waitTime', order: 0, isVisible: true },
            { title: 'Taşıma İrsaliyesi', name: 'warehouseReceipt', order: 0, isVisible: true },
            { title: 'Müşteri İrsaliye No', name: 'customerDeliveryNoteNumber', order: 0, isVisible: true },
            { title: 'Not', name: 'note', order: 0, isVisible: true },
            { title: 'Köprü Geçiş', name: 'isBridge', order: 0, isVisible: true },
            { title: 'Ek Lokasyon', name: 'isAdditionalLocation', order: 0, isVisible: true },
            { title: 'Bölüm', name: 'divisionName', order: 0, isVisible: true },
            { title: 'Po', name: 'poName', order: 0, isVisible: true },
            { title: 'Po Number', name: 'poNo', order: 0, isVisible: true },
            { title: 'Plaka', name: 'vehicleName', order: 0, isVisible: true },
            { title: 'Dorse Plaka', name: 'trailerName', order: 0, isVisible: true },
            { title: 'Sürücü', name: 'driverName', order: 0, isVisible: true },
            { title: 'Tedarikçi', name: 'supplierName', order: 0, isVisible: true },
            { title: 'Sipariş Tarihi', name: 'orderDateStr', order: 0, isVisible: true },
            { title: 'Yükleme Tarihi', name: 'loadDateStr', order: 0, isVisible: true },
            { title: 'Teslim Tarihi', name: 'deliveryDateStr', order: 0, isVisible: true },
            { title: 'Gönderici', name: 'senderCustomerName', order: 0, isVisible: true },
            { title: 'Alıcı', name: 'receiverCustomerName', order: 0, isVisible: true },
            { title: 'Yükleme İl', name: 'loadingCountyName', order: 0, isVisible: true },
            { title: 'Yükleme İlçe', name: 'loadingDistrictName', order: 0, isVisible: true },
            { title: 'Yükleme Semt', name: 'loadingNeighborhoodName', order: 0, isVisible: true },
            { title: 'Teslim İl', name: 'deliverCountyName', order: 0, isVisible: true },
            { title: 'Teslim İlçe', name: 'deliverDistrictName', order: 0, isVisible: true },
            { title: 'Teslim Semt', name: 'deliverNeighborhoodName', order: 0, isVisible: true },
            { title: 'Başlangıç Bölgesi', name: 'loadingRegionName', order: 0, isVisible: true },
            { title: 'Bitiş Bölgesi', name: 'deliverRegionName', order: 0, isVisible: true },
            { title: 'Teslim Eden', name: 'shippingDeliverer', order: 0, isVisible: true },
            { title: 'Teslim Alan', name: 'shippingReceiver', order: 0, isVisible: true },
            { title: 'Teslim Durumu', name: 'deliveryStatus', order: 0, isVisible: true },
                { title: 'E-İrsaliye', name: 'gibStatus', order: 0, isVisible: true },
            { title: 'Toplam Miktar (Adet)', name: 'totalQuantity', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Toplam Ağırlık', name: 'totalWeight', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Toplam Desi', name: 'totalDesi', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Toplam Hacimsel Ağırlık', name: 'totalDetailVolumetricWeight', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'E-İrsaliye Durumu', name: 'irsaliyeStatusName', order: 0, isVisible: true },
            { title: 'Satış Fatura Durumu', name: 'saleInvoiceStatus', order: 0, isVisible: true },
            { title: 'Alış Fatura Durumu', name: 'purchaseInvoiceStatus', order: 0, isVisible: true },
            { title: 'Satış Fatura Toplamı', name: 'saleInvoiceTotalAmount', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Alış Fatura Toplamı', name: 'purchaseInvoiceTotalAmount', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Satış Fatura Numaraları', name: 'saleInvoiceNumbers', order: 0, isVisible: true },
            { title: 'Alış Fatura Numaraları', name: 'purchaseInvoiceNumbers', order: 0, isVisible: true },
            { title: 'Sefer Durumu', name: 'ambarVoyageStatus', order: 0, isVisible: true },
            { title: 'Sefer No', name: 'ambarVoyageRefNo', order: 0, isVisible: true },
            { title: 'Sefer Başlama Tarihi', name: 'ambarVoyageStartDateStr', order: 0, isVisible: true },
            { title: 'Sefer Bitiş Tarihi', name: 'ambarVoyageEndDateStr', order: 0, isVisible: true },
            { title: 'Beklenen Gelir Toplamı', name: 'expectedIncomeTotals', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Beklenen Gider Toplamı', name: 'expectedOutcomeTotals', order: 0, isVisible: true, className: 'custom-text-right' },

            { title: 'Oluşturan', name: 'createdUser', order: 0, isVisible: true },
            { title: 'Güncelleyen', name: 'updatedUser', order: 0, isVisible: true }
            ];

        for (var i = 0; i < varsayilanlar.length; i++) {
            varsayilanlar[i].order = i + 1;
        }

        return kolonlariBirlestir(varsayilanlar, localStorage.getItem(pageName + "-" + pageVersion + "-filters"));
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({
            ...filter,
            currentPage: i,
            skip: (i - 1) * (filter.take ?? 0)
        });
    }

    const changeTake = (_take: number) => {
        getData({
            ...filter,
            currentPage: 1,
            skip: 0,
            take: _take
        });
    }

    // Panodaki bir karttan gelindiyse liste o kartin filtresiyle acilir.
    const location = useLocation();
    const gelenFiltreler: ColumnFilterModel[] | undefined = (location.state as any)?.columnFilters;

    // Liste zaten açıkken üst bardaki e-İrsaliye ikonuna basılınca da (location.key) gelen filtre uygulanır (07.10.2026).
    const ilkAcilis = useRef(true);

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    useEffect(() => {
        if (gelenFiltreler && gelenFiltreler.length > 0)
            getData({ ...filter, columnFilters: gelenFiltreler, currentPage: 1, skip: 0 });
        else if (ilkAcilis.current)
            getData();

        ilkAcilis.current = false;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.key])

    const deleteAmbar = async () => {
        try {
            var selectedIds = data.items.filter(x => x.isSelected).map(x => x.ambarId);

            dispatch(storeActivityIndicator(true))

            var response: DeleteAmbarResponse = await AmbarService.deleteAmbar(selectedIds);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success(response.message)

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const updateAmbar = async (_id: string | undefined = undefined) => {
        navigate('/ambar/listadd?id=' + (_id ? _id : data.items.filter(x => x.isSelected)[0].ambarId));
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: GetAmbarListPagingAndFilterRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true))

            var response: GetAmbarListPagingAndFilterResponse = await AmbarService.getAmbarListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);

            // E-İrsaliye Durumu: ekrandaki sonuçlanmamış siparişler arkada Uyumsoft'tan yenilenir (liste beklemez).
            UyumsoftService.refreshStatusesArkada(
                [],
                response.data.items.filter(x => !["GİB'e Gönderildi", 'Onaylandı', 'Kısmen Onaylandı', 'İptal', 'Silindi'].includes(x.irsaliyeStatusName ?? '')).map(x => x.ambarId));

            if (!trCountry) {
                var response2: GetCountryListResponse = await CountryService.getCountryList('TR');

                if (!response2.isSuccess) {
                    toast.error(response2.message)
                    return;
                }

                setTrCountry(response2.data.length > 0 ? response2.data[0] : undefined)
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Daha yeni bir istek sürüyorsa yükleniyor göstergesi açık kalır.
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.ambarId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.items.filter(x => x.companyId).length == data.items.filter(x => x.companyId && x.isSelected).length;

        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.companyId)
                    x.isSelected = !isAllSelected;

                return x;
            })
        })
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData();
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var obj: GetAmbarListPagingAndFilterRequest = buildExcelRequest(filter, mode, data.items.filter(x => x.isSelected).map(x => x.ambarId), columns);

            var response: ExportAmbarListResponse = await AmbarService.exportAmbarList(obj);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }


    // Başlığa tıklayarak sıralanabilen kolonlar. Ürünlerden/faturalardan hesaplanan
    // toplamlar (miktar, ağırlık, fatura durumu/tutarı) ve sefer durumu listede yok.
    const sortableColumns = [
        'refNo', 'customerName', 'transferDateStr', 'carryTypeName', 'carryMethodName', 'orderStatusName',
        'waitTime', 'warehouseReceipt', 'customerDeliveryNoteNumber', 'note', 'gibStatus',
        'isBridge', 'isAdditionalLocation', 'divisionName', 'poName', 'poNo',
        'orderDateStr', 'loadDateStr', 'deliveryDateStr',
        'senderCustomerName', 'receiverCustomerName',
        'loadingCountyName', 'loadingDistrictName', 'loadingNeighborhoodName',
        'deliverCountyName', 'deliverDistrictName', 'deliverNeighborhoodName',
        'loadingRegionName', 'deliverRegionName',
        'shippingDeliverer', 'shippingReceiver',
        'ambarVoyageRefNo', 'ambarVoyageStartDateStr', 'ambarVoyageEndDateStr',
        // Araç, dorse, sürücü ve tedarikçi sefer üzerinden gelir.
        'vehicleName', 'trailerName', 'driverName', 'supplierName',
        'createdUser', 'updatedUser'
    ];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    const getColumnValue = (item: GetAmbarListPagingAndFilterResponseItem, column: string, index: number, className: string | undefined) => {
        if (column == "refNo") {
            return (
                <td className={className} onClick={() => setItemSelected(item.ambarId)} onDoubleClick={() => updateAmbar(item.ambarId)}><a onClick={() => window.open(window.location.href + "add?id=" + item.ambarId, "_blank")} href='javascript:;'>{item.refNo}</a></td>
            )
        }
        else if (column == "ambarVoyageRefNo") {
            // Sefer No (19.10.2026): seferi yeni sekmede acan baglanti, siparis numarasindan farkli renkte.
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.ambarId)} onDoubleClick={!item.companyId ? undefined : () => updateAmbar(item.ambarId)}>
                    {
                        item.ambarVoyageId && item.ambarVoyageRefNo
                            ? <a className='text-info fw-bold text-hover-primary' onClick={(e) => { e.stopPropagation(); window.open(window.location.href.split('/ambar/list')[0] + '/ambarvoyage/listadd?id=' + item.ambarVoyageId, '_blank'); }} href='javascript:;'>{item.ambarVoyageRefNo}</a>
                            : item.ambarVoyageRefNo
                    }
                </td>
            )
        }
        else if (column == "createdUser") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.ambarId)} onDoubleClick={!item.companyId ? undefined : () => updateAmbar(item.ambarId)}>{item.createdUser} - {item.createdDate}</td>
            )
        }
        else if (column == "updatedUser") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.ambarId)} onDoubleClick={!item.companyId ? undefined : () => updateAmbar(item.ambarId)}>{item.updatedUser} - {item.updatedDate}</td>
            )
        }
        else if (['totalQuantity', 'totalWeight', 'totalDesi', 'totalDetailVolumetricWeight', 'saleInvoiceTotalAmount', 'purchaseInvoiceTotalAmount'].includes(column)) {
            var item2: any = item;
            return <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.ambarId)} onDoubleClick={!item.companyId ? undefined : () => updateAmbar(item.ambarId)}>{Helpers.correctPrice(item2[column], 2)}</td>;
        }
        else if (column == "isBridge") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.ambarId)} onDoubleClick={!item.companyId ? undefined : () => updateAmbar(item.ambarId)}>{item.isBridge ? "Evet" : "Hayır"}</td>
            )
        }
        else if (column == "irsaliyeStatusName") {
            // Hata durumunda nedenini görmek için hücrenin üstüne gelmek yeterli olsun.
            const baslik = [item.irsaliyeStatusMessage, item.irsaliyeStatusDateStr ? 'Son kontrol: ' + item.irsaliyeStatusDateStr : '']
                .filter(x => x).join('\n');

            return (
                <td className={className} title={baslik || undefined} onClick={!item.companyId ? undefined : () => setItemSelected(item.ambarId)} onDoubleClick={!item.companyId ? undefined : () => updateAmbar(item.ambarId)}>
                    <StatusBadge text={item.irsaliyeStatusName ?? ''} />
                </td>
            )
        }
        else if (column == "isAdditionalLocation") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.ambarId)} onDoubleClick={!item.companyId ? undefined : () => updateAmbar(item.ambarId)}>{item.isAdditionalLocation ? "Evet" : "Hayır"}</td>
            )
        }
        else if (column == "ambarVoyageStatus" || column == "saleInvoiceStatus" || column == "purchaseInvoiceStatus" || column == "orderStatusName" || column == "deliveryStatus" || column == "gibStatus") {
            // Durumlar renkli rozetle gösterilir (Faturalandı yeşil, Faturalanmadı kırmızı vb.).
            var item2: any = item;
            return <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.ambarId)} onDoubleClick={!item.companyId ? undefined : () => updateAmbar(item.ambarId)}><StatusBadge text={item2[column]} /></td>;
        }
        else {
            var item2: any = item;
            return <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.ambarId)} onDoubleClick={!item.companyId ? undefined : () => updateAmbar(item.ambarId)}>{item2[column]}</td>;
        }
    }

    // Kolon başlıklarının altındaki filtreler. Kolon adları backend'deki eşlemeyle
    // (AmbarManager.ApplyColumnFilters) aynı. Hesaplanan kolonların (toplamlar, fatura
    // toplamları/numaraları, beklenen gelir/gider toplamları) filtresi yok.
    const invoiceStatusOptions = (noneText: string): Promise<ColumnFilterOption[]> => Promise.resolve([
        { value: '1', label: 'Faturalandı' },
        { value: '2', label: 'Kısmi Faturalandı' },
        { value: '3', label: 'Faturalanmadı' },
        { value: '4', label: noneText },
    ]);

    // Teslim durumu, teslim tarihi ve teslim alan alanlarından hesaplanır; seçenekler sabit.
    const deliveryStatusOptions = (): Promise<ColumnFilterOption[]> => Promise.resolve([
        { value: '3', label: 'İşlenmedi' },
        { value: '2', label: 'Eksik Bilgi' },
        { value: '1', label: 'Teslim Edildi' },
        { value: '4', label: 'İptal' },
    ]);

    // E-irsaliye durumu siparisin yukleme tarihi ve GIB gonderim bayragindan hesaplanir.
    // Degerler sunucudaki metinlerle AYNI olmali; suzgec metinle karsilastiriyor.
    const gibStatusOptions = (): Promise<ColumnFilterOption[]> => Promise.resolve([
        { value: "GİB'e gönderilmedi", label: "GİB'e gönderilmedi" },
        { value: 'Gönderildi', label: 'Gönderildi' },
        { value: '(Boş)', label: '(Boş)' },
    ]);

    // Sefer durumu listede sefer başlangıç/bitiş tarihinden hesaplanır; seçenekler sabit.
    const voyageStatusOptions = (): Promise<ColumnFilterOption[]> => Promise.resolve([
        { value: '1', label: 'Sefer Başlamadı' },
        { value: '2', label: 'Sefer Başladı' },
        { value: '3', label: 'Sefer Bitti' },
    ]);

    const columnFilterDefinitions: ColumnFilterDefinitions = {
        refNo: { type: 'text' },
        // Durumlar Uyumsoft'tan geldiği için sabit listeden değil, yazarak süzülüyor.
        // "(Boş)" henüz gönderilmemiş ya da durumu okunmamış siparişleri getirir.
        // E-İrsaliye Durumu: adlar sunucudaki UyumsoftIntegrationManager.DurumAdi ile aynı; "(Boş)" = gönderilmemiş (07.10.2026).
        irsaliyeStatusName: { type: 'select', loadOptions: () => Promise.resolve(['Taslak', 'Kuyrukta', 'İşleniyor', "GİB'e Gönderildi", 'Onay Bekliyor', 'Onaylandı', 'Kısmen Onaylandı', 'İptal', 'Silindi', 'Hata'].map(x => ({ value: x, label: x }))), renderOption: (label) => <StatusBadge text={label} /> },
        customerName: { type: 'text' },
        transferDateStr: { type: 'date' },
        carryTypeName: { type: 'select', loadOptions: () => loadConstants('CARRY_TYPE') },
        carryMethodName: { type: 'select', loadOptions: () => loadConstants('CARRY_METHOD') },
        // Sipariş durumu sabit tanımlardan gelir; renkli rozetle gösterilir, "(Boş)" ile girilmemişler süzülür.
        orderStatusName: { type: 'select', loadOptions: () => loadConstants('ORDER_STATUS_AMBAR'), renderOption: (label) => <StatusBadge text={label} /> },
        waitTime: { type: 'number' },
        warehouseReceipt: { type: 'text' },
        customerDeliveryNoteNumber: { type: 'text' },
        note: { type: 'text' },
        isBridge: YES_NO_FILTER,
        isAdditionalLocation: YES_NO_FILTER,
        divisionName: { type: 'select', loadOptions: () => loadConstants('DIVISION') },
        poName: { type: 'select', loadOptions: () => loadList(ServiceService.getServiceList(true), 'serviceId', x => x.name) },
        poNo: { type: 'text' },
        vehicleName: { type: 'text' },
        trailerName: { type: 'text' },
        driverName: { type: 'text' },
        supplierName: { type: 'text' },
        orderDateStr: { type: 'date' },
        loadDateStr: { type: 'date' },
        deliveryDateStr: { type: 'date' },
        senderCustomerName: { type: 'text' },
        receiverCustomerName: { type: 'text' },
        // İl/ilçe/semt listeleri çok büyük; metinle aranır.
        loadingCountyName: { type: 'text' },
        loadingDistrictName: { type: 'text' },
        loadingNeighborhoodName: { type: 'text' },
        deliverCountyName: { type: 'text' },
        deliverDistrictName: { type: 'text' },
        deliverNeighborhoodName: { type: 'text' },
        // Bölgeler Proje-Bölge ekranındaki bölge listesinden (REGION) gelir.
        loadingRegionName: { type: 'select', loadOptions: () => loadConstants('REGION') },
        deliverRegionName: { type: 'select', loadOptions: () => loadConstants('REGION') },
        shippingDeliverer: { type: 'text' },
        shippingReceiver: { type: 'text' },
        // Fatura durumunda "(Boş)" yok; boş karşılığı "Beklenen Gelir/Gider Yok" seçeneği
        // (eski panelin "Beklenen Gelir/Gider Girilmemiş" anahtarları).
        saleInvoiceStatus: { type: 'select', allowEmpty: false, loadOptions: () => invoiceStatusOptions('Beklenen Gelir Yok'), renderOption: (label) => <StatusBadge text={label} /> },
        purchaseInvoiceStatus: { type: 'select', allowEmpty: false, loadOptions: () => invoiceStatusOptions('Beklenen Gider Yok'), renderOption: (label) => <StatusBadge text={label} /> },
        ambarVoyageStatus: { type: 'select', allowEmpty: false, loadOptions: voyageStatusOptions, renderOption: (label) => <StatusBadge text={label} /> },
        // Teslim durumu hesaplanan kolondur; "(Boş)" yoktur, dört durumdan seçilir.
        deliveryStatus: { type: 'select', allowEmpty: false, loadOptions: deliveryStatusOptions, renderOption: (label) => <StatusBadge text={label} /> },
        gibStatus: { type: 'select', allowEmpty: false, loadOptions: gibStatusOptions, renderOption: (label) => <StatusBadge text={label} /> },
        ambarVoyageRefNo: { type: 'text' },
        ambarVoyageStartDateStr: { type: 'date' },
        ambarVoyageEndDateStr: { type: 'date' },
        createdUser: { type: 'text' },
        updatedUser: { type: 'text' },
    };

    // Kolon filtresi değişince ilk sayfaya dönülür; sıralama ve sayfa boyu korunur.
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    // Dip toplam: görüntülenen sayfadaki kayıtların toplamı. Beklenen gelir/gider
    // döviz bazında gelir ("1.250,00 TRY, 45,00 USD"); her döviz alt alta yazılır.
    const getTotalValue = (columnName: string, columnIndex: number, className: string | undefined) => {
        const totals = data.totals;

        if (columnIndex == 0) {
            return <td className={className}>Toplam</td>;
        }

        if (columnName == 'expectedIncomeTotals' || columnName == 'expectedOutcomeTotals') {
            var text = (columnName == 'expectedIncomeTotals' ? totals?.expectedIncomeTotals : totals?.expectedOutcomeTotals) ?? '';

            return (
                <td className={className}>
                    {text.split(', ').filter(x => x != '').map(x => <div>{x}</div>)}
                </td>
            );
        }

        if (['totalQuantity', 'totalWeight', 'totalDesi', 'totalDetailVolumetricWeight', 'saleInvoiceTotalAmount', 'purchaseInvoiceTotalAmount'].includes(columnName)) {
            var totals2: any = totals;
            return <td className={className}>{Helpers.correctPrice(totals2 ? totals2[columnName] : 0, 2)}</td>;
        }

        return <td className={className}></td>;
    }

    // GİB gönderimi geri alınamaz: önce onay penceresi açılır, onaylanınca gönderilir.
    const [gibConfirmRefNos, setGibConfirmRefNos] = useState<string[] | undefined>(undefined);

    const saveAsDraftIrsaliye = async (_sendToGib: boolean) => {
        var selectedItems = data.items.filter(x => x.isSelected);

        if (selectedItems.length == 0)
            return;

        if (_sendToGib)
            setGibConfirmRefNos(selectedItems.map(x => x.refNo));
        else
            sendIrsaliye(false);
    }

    const confirmGib = () => {
        setGibConfirmRefNos(undefined);
        sendIrsaliye(true);
    }

    // Tek kayıt eskisi gibi hemen gönderilir; birden çok kayıt arka plan kuyruğuna alınır (her biri ayrı irsaliye).
    const sendIrsaliye = async (_sendToGib: boolean) => {
        var selectedItems = data.items.filter(x => x.isSelected);

        if (selectedItems.length == 0)
            return;

        if (selectedItems.length > 1) {
            enqueueIrsaliye(selectedItems.map(x => x.ambarId), _sendToGib);
            return;
        }

        try {
            dispatch(storeActivityIndicator(true))

            var response: SaveAsDraftIrsaliyeResponse = await UyumsoftService.saveAsDraftIrsaliye(selectedItems[0].ambarId, _sendToGib);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            if (response.data.isSucceded) {
                toast.success(response.data.message)
                getData();
            }
            else {
                toast.error(response.data.message)
                dispatch(storeActivityIndicator(false))
            }
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const enqueueIrsaliye = async (_ambarIds: string[], _sendToGib: boolean) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: EnqueueJobResponse = await JobQueueService.enqueueIrsaliye(_ambarIds, _sendToGib);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            if (response.data.queuedCount > 0) {
                jobQueueTracker.add(response.data.batchId, _sendToGib ? 'E-İrsaliye GİB (Uyumsoft)' : 'E-İrsaliye Taslak (Uyumsoft)');
                toast.success(response.message + ' İlerleme sağ altta görünür.')
            }
            else {
                toast.error(response.message)
            }

            // Atlanan kayıtlar nedeniyle birlikte gösterilir (zaten GİB'e gitmiş, zaten kuyrukta vb.).
            if (response.data.skipped.length > 0) {
                const lines = response.data.skipped.slice(0, 5).map(x => (x.refNo ?? '') + ': ' + x.reason);
                const more = response.data.skipped.length > 5 ? `\n… ve ${response.data.skipped.length - 5} kayıt daha` : '';
                toast(lines.join('\n') + more, { duration: 8000, icon: '⚠️' })
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Kuyruktaki toplu iş bitince liste yenilenir (Aktarım No / durum kolonları güncellensin).
    const getDataRef = useRef<() => void>(() => { });
    getDataRef.current = () => getData();

    useEffect(() => {
        const onCompleted = () => getDataRef.current();
        window.addEventListener(JOB_QUEUE_BATCH_COMPLETED_EVENT, onCompleted);
        return () => window.removeEventListener(JOB_QUEUE_BATCH_COMPLETED_EVENT, onCompleted);
    }, [])

    /**
     * Uyumsoft'ta hataya dusmus irsaliyeyi taslaga cevirir. Geri cekmeden farki:
     * belge iptal edilmez, NUMARA KORUNUR. Duzeltip ayni numarayla yeniden gonderilir.
     */
    const moveToDraftIrsaliye = async () => {
        try {
            var selectedItems = data.items.filter(x => x.isSelected);

            if (selectedItems.length == 0)
                return;

            dispatch(storeActivityIndicator(true))

            var response: MoveToDraftIrsaliyeResponse = await UyumsoftService.moveToDraftIrsaliye(selectedItems[0].ambarId);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            if (response.data.isSucceded) {
                toast.success(response.data.message)
                getData();
            }
            else {
                toast.error(response.data.message)
                dispatch(storeActivityIndicator(false))
            }
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    // Geri cekme numarayi serbest birakir: once onay penceresi acilir, onaylaninca calisir.
    const [cancelDraftItem, setCancelDraftItem] = useState<{ ambarId: string } | undefined>(undefined);

    const cancelDraftIrsaliye = async () => {
        var selectedItems = data.items.filter(x => x.isSelected);

        if (selectedItems.length == 0)
            return;

        setCancelDraftItem({ ambarId: selectedItems[0].ambarId });
    }

    const confirmCancelDraft = () => {
        var secilen = cancelDraftItem;

        setCancelDraftItem(undefined);

        if (secilen)
            runCancelDraftIrsaliye(secilen.ambarId);
    }

    const runCancelDraftIrsaliye = async (_ambarId: string) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: CancelDraftIrsaliyeResponse = await UyumsoftService.cancelDraftIrsaliye(_ambarId);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            if (response.data.isSucceded) {
                toast.success(response.data.message)
                getData();
            }
            else {
                toast.error(response.data.message)
                dispatch(storeActivityIndicator(false))
            }
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const navigateToFindPrice = () => {
        var ids = data.items.filter(x => x.isSelected).map(x => x.ambarId);
        localStorage.setItem('SelectedIds', JSON.stringify(ids));
        navigate('/ambar/listfindprice')
    }

    const copyItem = () => {
        window.open(window.location.href + "add?copyid=" + data.items.find(x => x.isSelected)?.ambarId, "_blank");
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <AmbarListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    getData={getData}
                    setFilter={setFilter}
                    selectedCount={data.items.filter(x => x.isSelected).length}
                    trCountry={trCountry}
                    saveAsDraftIrsaliye={saveAsDraftIrsaliye}
                    cancelDraftIrsaliye={cancelDraftIrsaliye}
                    moveToDraftIrsaliye={moveToDraftIrsaliye}
                    navigateToFindPrice={navigateToFindPrice}
                    items={data.items}
                    deleteFunction={deleteAmbar}
                    updateFunction={updateAmbar}
                    onSearchSubmit={onSearchSubmit}
                    copyItem={copyItem}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2 px-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className="new-table-container">
                            <table className="ebbe-table-fill">
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.items.filter(x => x.isSelected).length > 0 && data.items.filter(x => x.isSelected).length == data.items.filter(x => x.companyId).length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>

                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item, index) =>
                                            <tr style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    {
                                                        item.companyId && (
                                                            <div className='d-flex'>
                                                                <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                                    <input onChange={() => setItemSelected(item.ambarId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                                </label>
                                                            </div>
                                                        )
                                                    }
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }

                                    {
                                        /* Az kayıt geldiğinde kalan boşluğu doldurur; dip toplam satırı
                                           tablonun altına iner, çerçeve hep aynı yerde kalır. */
                                        data.items.length > 0 && (
                                            <tr className="ebbe-table-filler">
                                                <td colSpan={99}></td>
                                            </tr>
                                        )
                                    }
                                </tbody>

                                {
                                    data.items.length > 0 && (
                                        <tfoot>
                                            <tr>
                                                <td style={{ width: 1 }}></td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getTotalValue(column.name, columnIndex, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        </tfoot>
                                    )
                                }
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={(filter.take ?? 0)}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / (filter.take ?? 0))}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={data.items.filter(x => x.isSelected).length}
                    />
                </KTCard>
            </Content>

            <CancelDraftConfirmModal
                isShown={cancelDraftItem !== undefined}
                onConfirm={confirmCancelDraft}
                onClose={() => setCancelDraftItem(undefined)}
            />

            <GibConfirmModal
                isShown={gibConfirmRefNos !== undefined}
                refNos={gibConfirmRefNos ?? []}
                onConfirm={confirmGib}
                onClose={() => setGibConfirmRefNos(undefined)}
            />
        </React.Fragment>
    )
}

export default AmbarList;